import { useMainPageContext } from "@/contexts/MainPageContext";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useMemo } from "react";
import { StyledMenuItemContent } from "./general-promotion-select-styled";
import { formatCurrency } from "@/helper/common";
import { getPromotionName } from "@/helper/promotions";

export function GeneralPromotionSelect() {
  const {
    promotions,
    choosenGeneralPromotion,
    setChoosenGeneralPromotion,
    isGeneralPromotionApplicable,
  } = useMainPageContext();
  const availablePromotions = useMemo(() => {
    return promotions.filter((promotion) => !promotion.itemId);
  }, [promotions]);

  const getPromoDiscount = (promotion) => {
    if (promotion.promoDiscountType === "Porcentaje") {
      return `${promotion.discountValue}%`;
    }
    return formatCurrency(promotion.discountValue);
  };

  const getPromoSubtitle = (promotion) => {
    if (promotion.minPurchaseValue) {
      return `Para productos desde: ${formatCurrency(promotion.minPurchaseValue)}`;
    }
    return "";
  };
  if (availablePromotions.length === 0) {
    return null;
  }

  return (
    <FormControl sx={{ width: "100%", padding: 0, margin: 0 }}>
      <InputLabel id="demo-simple-select-disabled-label">Promoción</InputLabel>
      <Select
        labelId="demo-simple-select-disabled-label"
        id="demo-simple-select-disabled"
        value={choosenGeneralPromotion?.promoId ?? "-1"}
        label="Promoción"
        sx={{
          "& .MuiSelect-select": {
            padding: 1,
          },
        }}
        onChange={(event) => {
          const selectedPromotion = promotions.find(
            (promo) => promo.promoId === event.target.value,
          );
          setChoosenGeneralPromotion(selectedPromotion);
        }}
      >
        <MenuItem value="-1">
          <em>Ninguna promocion</em>
        </MenuItem>
        {availablePromotions.map((promotion) => (
          <MenuItem
            disabled={!isGeneralPromotionApplicable(promotion)}
            key={promotion.promoId}
            value={promotion.promoId}
          >
            <StyledMenuItemContent>
              <h6 className="title">{getPromotionName(promotion)}</h6>
              <span className="subtitle">{getPromoSubtitle(promotion)}</span>
              <span className="price">{getPromoDiscount(promotion)} OFF</span>
            </StyledMenuItemContent>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
